import { call } from 'redux-saga/effects';
import { get, map, set, omitBy } from 'lodash/fp';
import moment from 'moment';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import {
  fetchInventoryActionOptions as fetchInventoryActionOptionsRoutine,
  fetchInventoryAuditLogsForItem as fetchInventoryAuditLogsForItemRoutine
} from './routines';

export const fetchInventoryActionOptions = () =>
  sagaRoutineRequest(fetchInventoryActionOptionsRoutine, {
    request: () => call(Api.fetchInventoryActionOptions)
  });

export const fetchInventoryAuditLogsForItem = ({ payload = {} }) => {
  const qs = omitBy(each => !each, payload);
  const createdAt = get('createdAt', qs);
  const formatDates = map(each => moment(each).format('YYYY-MM-DD'));
  const options = createdAt
    ? { qs: set('createdAt', formatDates(createdAt), qs) }
    : { qs };
  return sagaRoutineRequest(fetchInventoryAuditLogsForItemRoutine, {
    request: () => call(Api.fetchInventoryAuditLogsForItem, options)
  });
};
